import { Tone } from 'components/DocRightRail/screens/AIAssistant/ToneSelect'
import { Selection } from 'prosemirror-state'
import { AlmanacFile } from 'types'
import { Data } from 'hooks/queries/layers/aiSuggestionNodes/useCreateAISuggestionNode'
import * as React from 'react'
import { FormSchema, FormStatus } from 'components/Wizards/Wizard/Form/Types'

export interface InitialValues {
  title?: string
  introduction?: string
  outline?: string
  topic?: string
  goal?: string
  audience?: string
  seo_words?: Array<string>
  tone?: Array<Tone>
  brand_voice_id?: number
  call_to_action?: string
  author_persona?: string
  product_description?: string
  avoid?: string
  additional_info?: string
  blog_length?: BlogPostLength
  project?: AlmanacFile
  include_images?: boolean
  promotion?: string
  language?: string
}

export interface BlogPostWizardProps {
  initialValues?: InitialValues
  initialFormStatus?: FormStatus
  articleId?: string
  layerId?: string
  nodeSelection?: Selection
  seasonalPromotion?: 'black_friday'
  isTurnInto?: boolean
  onSuccess?: (data: { almanac_file: AlmanacFile } | Data) => void
  children?: (props: {
    submitForm: () => Promise<Data | { almanac_file: AlmanacFile }>
    isSubmitting: boolean
  }) => React.ReactNode
  schema: FormSchema
}

export enum BlogPostLength {
  Short = 'short',
  Medium = 'medium',
  Long = 'long',
}
